import React, {Component} from "react";
import AssociatePerformance from "./AssociatePerformance";
import AssociateFilterContextProvider from "./context/AssociateFilterContext";
import AssociateFilter from "./AssociateFilter";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContext";

class Associate extends Component {
    render() {
        return (
            <AssociateFilterContextProvider>
                <AssociateFilter/>
                <AssociatePerformanceContextProvider>
                    <AssociatePerformance/>
                </AssociatePerformanceContextProvider>
            </AssociateFilterContextProvider>
        )
    }
}
export default Associate


// WEBPACK FOOTER //
// ./src/components/associate/Associate.js